import { Box } from "@chakra-ui/react";
import GuidedCampaignFlow, {
  type GuidedCampaignFlowProps,
} from "../guidedFlow/GuidedCampaignFlow";

/**
 * Full-screen layout for the create-campaign flow.
 * Used by ManagedCampaignsSection (event context) and AdsEngagePage (org-level).
 */
export default function GuidedCreateCampaignFlowScreen(
  props: GuidedCampaignFlowProps
) {
  return (
    <Box
      position="relative"
      minH="calc(100vh - 24px)"
      bg="gray.300"
      backgroundImage="linear-gradient(rgba(0,0,0,.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,.05) 1px, transparent 1px)"
      backgroundSize="24px 24px"
      borderRadius="md"
    >
      <Box py={6} px={[4, 8]} maxW="7xl" mx="auto">
        <GuidedCampaignFlow {...props} />
      </Box>
    </Box>
  );
}
